import React, { FC } from 'react';

interface IProps {
  className?: string;
}

const IconUser: FC<IProps> = ({ className }) => {
  return (
    <>
      <svg className={className} viewBox="0 0 11 14" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.37007 7.31733C8.52092 6.63611 9.2939 5.37248 9.2939 3.92621C9.2939 1.75782 7.55633 0 5.41292 0C3.26953 0 1.53196 1.75782 1.53196 3.92621C1.53196 5.35525 2.28666 6.60599 3.41485 7.29278C2.72982 7.56287 2.10039 7.97515 1.57045 8.51128C0.56491 9.52854 0 10.9082 0 12.3469V13.2767C0 13.6762 0.320079 14 0.714915 14H10.0599C10.4547 14 10.7748 13.6762 10.7748 13.2767V12.3469H10.7237C10.7237 10.9082 10.1588 9.52854 9.15328 8.51128C8.63915 7.99116 8.03138 7.58757 7.37007 7.31733ZM1.02131 12.3469H0.979681C0.979681 11.1711 1.44138 10.0435 2.26319 9.21207C3.08501 8.38069 4.19962 7.91363 5.36186 7.91363C6.5241 7.91363 7.63872 8.38069 8.46053 9.21207C9.28233 10.0435 9.74405 11.1711 9.74405 12.3469H9.75349V12.9668H1.02131V12.3469ZM5.41292 6.83376C3.82562 6.83376 2.53886 5.53201 2.53886 3.92621C2.53886 2.3204 3.82562 1.01863 5.41292 1.01863C7.00022 1.01863 8.28701 2.3204 8.28701 3.92621C8.28701 5.53201 7.00022 6.83376 5.41292 6.83376ZM4.08522 10.7971C3.8032 10.7971 3.57457 11.0283 3.57457 11.3137C3.57457 11.599 3.8032 11.8303 4.08522 11.8303H6.79168C7.07371 11.8303 7.30233 11.599 7.30233 11.3137C7.30233 11.0283 7.07371 10.7971 6.79168 10.7971H4.08522Z"
        />
      </svg>
    </>
  );
};

export default IconUser;
